<footer class="footer">
  <div class="container primary-content row">
    <span class="copyright" >{{'© '+year+' Cancer Support Community.' | translate}}</span>
  </div>
</footer>
